<template>
    <div class="filter-bar">
        <div>
            {{ $t('askPendo.filterBar.Filters') }}:
        </div>
        <div
            v-for="(value, key) in filters"
            :key="key"
            class="filter-bar__filter">
            {{ key }}: {{ value }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'FilterBar',
    props: {
        filters: {
            type: Object,
            default: null,
        },
    },
};
</script>

<style scoped lang="less">
.filter-bar {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    padding: 8px 16px;
    font-size: 12.642px;
    font-weight: 600;
    line-height: 150%;
    &__filter {
        padding: 4px 8px;
        border: 1px solid var(--palette-gray-40);
        border-radius: 4px;
        height: fit-content;
    }
}
</style>